// Shared category vocabulary for FLYT case studies / examples.
// Used by:
//   - CaseStudiesGrid (homepage filter chips)
//   - FlytCaseStudiesPage (full library filter chips)
//   - FlytExamplesTab (admin dropdown)
// Update this list to add new content types.
export const FLYT_CATEGORIES = [
  'Corporate',
  'Podcast',
  'Short Form',
  'YouTube',
  'Real Estate',
  'Brand Film',
  'Documentary',
  'Athlete',
  'Editorial',
];
